import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import PasswordField from "../../common/PasswordField";
import eventAnalytics from "../../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../../utils/constants";

export class InstantCredentialsForm extends React.Component {
  constructor(props) {
    super(props);

    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.INSTANT_CREDENTIALS_FORM);
    eventAnalytics.setFlowName(ANALYTIKA_EVENTS.FLOW.MERCHANT_OPERATOR);
    eventAnalytics.publishViewPage(
      ANALYTIKA_EVENTS.PAGE.INSTANT_CREDENTIALS_FORM
    );
  }

  render() {
    const { t, error, submitting } = this.props;
    const userIdError = error === "User ID is required" ? error : null;
    const passwordError = error === "Password is required" ? error : null;
    const generalError = error && !userIdError && !passwordError ? error : null;
    return (
      <form
        data-request-type="instant_credentials_submit"
        onSubmit={this.props.onSubmit}
        noValidate
      >
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        <LanguageSelector />
        <h1>{t("login:title")}</h1>


  {generalError && <div className="invalid show">{generalError}</div>}

        <div className="material-form-field">
          <input
            autoFocus
            type="text"
            autoComplete="username"
            id="instantCredentialsUserId"
            name="instantCredentialsUserId"
            onChange={this.props.onInstantCredentialsUserIdChange}
            required={true}
          />
          <label className="material-form-field-label" htmlFor="instantCredentialsUserId">
            {t("login:user_id")}
          </label>
          {userIdError && <div className="invalid show">{userIdError}</div>}
        </div>

        <PasswordField
          id="password"
          name="password"
          label={t("login:password")}
          onChange={this.props.onPasswordChange}
          autoComplete="current-password"
          required
          variant="classic"
        />
        {passwordError && <div className="invalid show">{passwordError}</div>}

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="verify-recover-btn"
          disabled={submitting}
        />

        <ReCaptcha />
      </form>
    );
  }
}

InstantCredentialsForm.propTypes = {
  t: Types.func.isRequired,
  error: Types.string,
  onInstantCredentialsUserIdChange: Types.func.isRequired,
  onPasswordChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
  submitting: Types.bool.isRequired,
};
export default withTranslation()(InstantCredentialsForm);
